import ReactECharts from 'echarts-for-react';
import React, { useEffect, useState } from 'react';
import Papa from 'papaparse';
import { ResponsiveChord } from '@nivo/chord';
import { Box, Slider, Typography } from '@mui/material';
import { color } from 'echarts';


const color_map_base_chord = {
  "Tierras de cultivo": "#B8860B",
  "Inundado": "#4169E1",
  "Bosques primarios": "#006400",
  "Bosques secundarios": "#228B22",
  "Pastizales": "#90EE90",
  "Otro": "#9932CC",
  "Pastizales p/ganado": "#FFD700",
  "Asentamientos": "#808080",
  "Matorrales": "#FFA07A",
  "Humedales": "#40E0D0",
}

const color_map_base_chord_OG = {
"Croplands": "#B8860B",
"Flooded": "#4169E1",
"Forests_primary": "#006400",
"Forests_secondary": "#228B22",
"Grasslands": "#90EE90",
"Other": "#9932CC",
"Pastures": "#FFD700",
"Settlements": "#808080",
"Shrublands": "#FFA07A",
"Wetlands": "#40E0D0",
}


const color_map_base = {
  "Tierras de cultivo": "#B8860B",
  "Inundado": "#4169E1",
  "Bosques primarios": "#006400",
  "Bosques secundarios": "#228B22",
  "Pastizales": "#90EE90",
  "Otro": "#9932CC",
  "Pastizales p/ganado": "#FFD700",
  "Asentamientos": "#808080",
  "Matorrales": "#FFA07A",
  "Humedales": "#40E0D0",
}

const color_map_base_OG = {
"Croplands": "#B8860B",
"Flooded": "#4169E1",
"Primary forests": "#006400",
"Secondary forests": "#228B22",
"Grasslands": "#90EE90",
"Other": "#9932CC",
"Pastures": "#FFD700",
"Settlements": "#808080",
"Shrublands": "#FFA07A",
"Wetlands": "#40E0D0",
}

const COLUMN_NAME_MAP = {
  croplands: 'Tierras de cultivo',
  flooded: 'Inundado',
  forests_primary: 'Bosques primarios',
  forests_secondary: 'Bosques secundarios',
  grasslands: 'Pastizales',
  other: 'Otro',
  pastures: 'Pastizales p/ganado',
  settlements: 'Asentamientos',
  shrublands: 'Matorrales',
  wetlands: 'Humedales',
};

const COLUMN_NAME_MAP_OG = {
  croplands: 'Croplands',
  flooded: 'Flooded',
  forests_primary: 'Primary forests',
  forests_secondary: 'Secondary forests',
  grasslands: 'Grasslands',
  other: 'Other',
  pastures: 'Pastures',
  settlements: 'Settlements',
  shrublands: 'Shrublands',
  wetlands: 'Wetlands',
};

const NAME_MAP = {
  emission_co2e_subsector_total_frst:        'Bosques',
  emission_co2e_subsector_total_lndu:        'Transiciones de uso de suelo',
  emission_co2e_co2_soil_soc_mineral_soils:  'Mineralización del suelo',
  emission_co2e_n2o_soil_mineral_soils:      'Mineralización del suelo (N₂O eq.)',
  emission_co2e_n2o_soil_organic_soils:      'Suelo orgánico (N₂O eq.)',
}

export const BosquesPrimSecChart = () => {
  const [years, setYears] = useState([]);
  const [values, setValues] = useState([]);

  useEffect(() => {
    Papa.parse('/data/csv/area.csv', {
      download:       true,
      header:         true,
      dynamicTyping:  true,
      skipEmptyLines: true,
      complete: ({ data }) => {
        if (!data.length) return console.error('CSV load error');

        const yearCols = Object.keys(data[0]).filter(k => k !== 'label');

        const pivoted = yearCols.map(offset => {
          const year = String(2000 + Number(offset));
          const entry = { year };
          data.forEach(row => {
          
            const colName = COLUMN_NAME_MAP[row.label];
            entry[colName] = (row[offset] || 0) / 100;
          });

         

          return entry;
        })
        // keep only 2000–2020
        .filter(d => +d.year >= 2000 && +d.year <= 2020);

        

        // **THIS** is your axis=1 sum:
        // for each year-object, add Primary + Secondary
        const ys = pivoted.map(d => d.year);
        const vs = pivoted.map(
          d => (d['Primary forests'] || 0) + (d['Secondary forests'] || 0)
        );


        setYears(ys);
        setValues(vs);
      }
    });
  }, []);


  const option = {
    title: { text: 'Área de bosques primarios y secundarios' },
    textStyle : {color: '#fff'},
    tooltip: { trigger: 'axis' },
    xAxis: { type: 'category', data: years },
    yAxis: { type: 'value', name: 'Área (km²)' },
    series: [
      {
        name: 'Bosques',
        type: 'line',
        data: values,
        smooth: false,
        lineStyle: { width: 2 },
        itemStyle: { color: color_map_base['Primary forests'] }, // Added itemStyle here
        markArea: {
          itemStyle: { color: 'rgba(255,0,0,0.2)' },
          data: [
            [{ xAxis: '2002' }, { xAxis: '2004' }],
            [{ xAxis: '2011' }, { xAxis: '2013' }],
          ]
        }
      }
    ]
  };

  return <ReactECharts option={option} style={{ height: 500, width: '50%' }} />;
};

export  function MaskedStackedArea() {
    const baseOption = {
      tooltip: { trigger: 'axis' },
      legend: {
        orient: 'vertical',
        right: 10,
        top: 20,
        bottom: 20,
        textStyle : {color: '#fff'},
        show: true,
        icon:"circle"
      },
      textStyle : {color: '#fff'},
      grid: { left: '0%', right: '30%', bottom: '30%', containLabel: true },
      xAxis: {
        name: 'Año',
        type: 'category',
        boundaryGap: false,
        axisLabel: { rotate: 90 }
      },
      yAxis: {
        type: 'value',
        name: 'Área (km²)',
        axisLabel: {
          formatter: v =>
        v.toLocaleString(undefined, { minimumFractionDigits: 0 })
        },
      },
      series: []             // ← will fill this in later
    };
  const [option, setOption] = useState(baseOption);

  useEffect(() => {
    Papa.parse('/data/csv/area.csv', {
      download: true,
      header: true,
      complete: ({ data }) => {
        // --- pivot & mask logic ---
        const classes = data.map(row => {
          const name = COLUMN_NAME_MAP[row.label] || row.label;
          const values = Object.entries(row)
            .filter(([k]) => k !== 'label')
            .map(([off, v]) => ({
              year: String(2000 + +off),
              value: +v / 100
            }))
            .filter(d => +d.year >= 2000 && +d.year <= 2020);
          return { name, values };
        });

        const years = Array.from(
          new Set(classes.flatMap(c => c.values.map(v => v.year)))
        ).sort();

        const totalByYear = years.reduce((acc, y) => {
          acc[y] = classes
            .map(c => c.values.find(v => v.year === y)?.value || 0)
            .reduce((s, x) => s + x, 0);
          return acc;
        }, {});

        const filtered = classes.filter(c =>
          c.values.some(v => v.value / (totalByYear[v.year]||1) >= 0.01)
        );

        const series = filtered.map(c => ({
          name: c.name,
          type: 'line',
          stack: 'Total',
          smooth: true,
          areaStyle: {},
          lineStyle: { width: 0 },
          emphasis: { focus: 'series' },
          itemStyle: { color: color_map_base[c.name] },
          data: years.map(y => {
            const val = c.values.find(v => v.year === y)?.value || 0;
            return Math.round(val * 100) / 100;
          })
        }));

        // 3) merge in the computed axes & series
        setOption(opt => ({
          ...opt,
          xAxis: { ...opt.xAxis, data: years },
          series
        }));
      }
    });
  }, []);

  return (
    <ReactECharts
      option={option}
      style={{ height: "130%", width: '100%' }}
      notMerge={true}
      lazyUpdate={true}
    />
  );
}

export function MyChord() {
  const THRESHOLD = 10 * 1e6
  const [matrix, setMatrix] = useState([])
  const [keys, setKeys] = useState([])
  const [colors, setColors] = useState([])

  useEffect(() => {
    Papa.parse('/data/csv/table_extra.csv', {
      download: true,
      header: true,
      dynamicTyping: true,
      skipEmptyLines: true,
      complete: ({ data }) => {
        // 1. extract all category-columns (everything except the 'start' index)
        const categories = Object.keys(data[0]).filter((c) => c !== 'start')

        // 2. compute column sums and row sums
        const colSums = {}
        categories.forEach((cat) => {
          colSums[cat] = data.reduce((sum, row) => sum + (row[cat] || 0), 0)
        })
        const rowSums = {}
        data.forEach((row) => {
          rowSums[row.start] = categories.reduce(
            (sum, cat) => sum + (row[cat] || 0),
            0
          )
        })

        // 3. pick only those categories with both colSum > THRESHOLD and rowSum > THRESHOLD
        const wanted = categories.filter(
          (cat) => colSums[cat] > THRESHOLD && rowSums[cat] > THRESHOLD
        )

        // 4. filter your rows to only those whose index ('start') is in wanted
        const filteredRows = data.filter((row) => wanted.includes(row.start))

        // 5. build the matrix and zero out the diagonal
        const mat = filteredRows.map((row, i) =>
          wanted.map((cat, j) => (i === j ? 0 : row[cat] || 0))
        )

        // 6. map keys → display names and colors
        const displayKeys = wanted.map((cat) => COLUMN_NAME_MAP[cat] || cat)
        const displayColors = wanted.map(
          (cat) => {
            const displayName = COLUMN_NAME_MAP[cat] || cat;
            return color_map_base_chord[displayName] || '#999';
          }
        )

        setMatrix(mat)
        setKeys(displayKeys)
        setColors(displayColors)
      },
    })
  }, [])


  return (
    <div style={{ height: "105%", width: '100%' }}>
      <ResponsiveChord
        data={matrix}
        keys={keys}
        colors={colors}
        margin={{ top: 5, right: 100, bottom: 15, left: 60 }}
        padAngle={0.1}
        labelTextColor="#fff"
        enableLabel={false}
        innerRadiusRatio={0.8}
        innerRadiusOffset={0.02}
        valueFormat={v =>
          v.toLocaleString(undefined, {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
          })
        }
        legends={[
          {
            anchor: 'right',
            direction: 'column',
            translateY: -20,
            itemWidth: 100,
            itemHeight: 16,
            itemsSpacing: 14,
            symbolShape: 'circle',
            itemTextColor: '#fff',
            font: {
              fontSize: 12,
              fontWeight: 'normal',
              font: '14px / 21px sans-serif'
            },
          },
        ]}
        arcTooltip={({ arc }) => (
          <div
            style={{
              background: 'white',
              color: 'black',
              padding: '9px 12px',
              border: '1px solid #ccc',
              borderRadius: 2,
              boxShadow: '0 1px 2px rgba(0,0,0,0.25)',
              minWidth: 120,
              pointerEvents: 'none',
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              gap: 16,
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <span
                style={{
                display: 'inline-block',
                width: 15,
                height: 15,
                backgroundColor: arc.color,
                marginRight: 0,
                marginLeft: 0,
              }}
              />
              <span> <strong>{arc.id}</strong></span>
            </div>
            <div>
              {arc.value.toLocaleString(undefined, {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0
              })}
            </div>
          </div>
        )}
      />
    </div>
  )
}

export function CarbonStackedLineChart() {
  const baseOption = {
    tooltip: {
      trigger: 'axis',
      axisPointer: { type: 'shadow' },
    },
    legend: {
      data: [],
      top: 0,
      left: 'center',
      textStyle: { color: '#fff' },
      icon: "roundRect"
    },
    grid: { top: 100, right: 100, bottom: 60, left: 100 },
    xAxis: {
      name: 'Año',
      type: 'category',
      data: [],
      axisLabel: { rotate: 90 },
    },
    textStyle: { color: '#fff' },
    yAxis: {
      type: 'value',
      name: 'CO₂ emitido (millones de toneladas)',
    },
    series: [],
  }
  const [option, setOption] = useState(baseOption)

  useEffect(() => {
    Papa.parse('/data/csv/emissions.csv', {
      download: true,
      header: true,
      dynamicTyping: true,
      complete: ({ data }) => {
        // filter & prep
        const rows = data.filter(r => r.time_period != null && r.time_period < 21)
        const years = rows.map(r => r.time_period + 2000)
        const keys = Object.keys(NAME_MAP)

        // Compute stacks and filter out categories that are all zero
        const stacks = keys.map(key => rows.map(r => +(r[key] || 0).toFixed(2)))
        const nonZeroIdx = stacks
          .map((values, idx) => ({ idx, hasNonZero: values.some(v => v !== 0) }))
          .filter(x => x.hasNonZero)
          .map(x => x.idx)
        const filteredKeys = nonZeroIdx.map(idx => keys[idx])
        const filteredStacks = nonZeroIdx.map(idx => stacks[idx])

        const net = years.map((_, i) =>
          +(filteredStacks.reduce((sum, series) => sum + series[i], 0).toFixed(2))
        )

        // build the bar series + one line series
        const series = [
          ...filteredStacks.map((values, idx) => ({
            name: NAME_MAP[filteredKeys[idx]],
            type: 'bar',
            stack: 'stack',
            data: values,
          })),
          {
            name: 'Neto',
            type: 'line',
            data: net,
            lineStyle: { width: 2 },
            itemStyle: { color: '#000' },
          },
        ]

        setOption({
          ...baseOption,
          legend: {
            ...baseOption.legend,
            data: [...filteredKeys.map(k => NAME_MAP[k]), 'Neto'],
          },
          xAxis: {
            ...baseOption.xAxis,
            data: years,
          },
          series,
        })
      },
    })
  }, [])

  return (
    <ReactECharts
      style={{ height: "100%", width: '100%' }}
      option={option}
      notMerge={true}
      lazyUpdate={true}
    />
  )
}

export function TransitionsEmissionsChart() {

  function prettifyColumn(rawKey) {
  const prefix = "emission_co2e_co2_lndu_conversion_"
  if (!rawKey.startsWith(prefix)) return rawKey
  const [start, end] = rawKey
    .slice(prefix.length)
    .split("_to_")
  return `${COLUMN_NAME_MAP[start]}-${COLUMN_NAME_MAP[end]}`
}

  const baseOption = {
 
  textStyle : {color: '#fff'},

  tooltip: {
    trigger: 'axis',
    axisPointer: { type: 'shadow' },
  },
  legend: {
    data: [],       // ← will fill this dynamically
    top: 0,
    right: 0,
    textStyle : {color: '#fff'},
  },
  grid: {
    top: 40,
    left: 75,
    right: 100,
    bottom: 130,
    containLabel: true,
  },
  xAxis: {
    name: 'Año',
    type: 'category',
    data: [],       // ← fill dynamically
    axisLabel: { rotate: 90 },
  },
  yAxis: {
    type: 'value',
    name: 'CO₂ emitido (millones de toneladas)',
  },
  series: []       // ← fill dynamically
}

  const [option, setOption] = useState(baseOption)

  useEffect(() => {
    Papa.parse('/data/csv/transitions_emissions.csv', {
      download: true,
      header: true,
      dynamicTyping: true,
      skipEmptyLines: true,
      complete: ({ data }) => {
        // assign year=2000…2035, then filter to ≤2020
        const rows = data
          .map((r, i) => ({ ...r, year: 2000 + i }))
          .filter(r => r.year <= 2020)

        // group by (year, end)
        const grouping = {}
        rows.forEach(r => {
          Object.entries(r).forEach(([key, val]) => {
            if (key === 'year' || key.startsWith('Unnamed')) return
            const pretty = prettifyColumn(key)                // e.g. "Croplands-Pastures"
            const [, end] = pretty.split('-')                 // e.g. "Pastures"
            if (!['Tierras de cultivo','Pastizales p/ganado','Asentamientos'].includes(end)) return
            grouping[r.year] = grouping[r.year] || {}
            grouping[r.year][end] = +( (grouping[r.year][end] || 0) + Number(val || 0) ).toFixed(2)
          })
        })

        // sorted years
        const years = Object.keys(grouping)
          .map(y => Number(y))
          .sort((a, b) => a - b)

        // build bar series for each end-class
        const ends = ['Tierras de cultivo','Pastizales p/ganado','Asentamientos']
        const barSeries = ends.map(end => (

          {
          name: end,
          type: 'bar',
          stack: 'total',
          
          itemStyle: {
            color: color_map_base[
              end
            ]
          },
          data: years.map(y => grouping[y][end] || 0)
        }))

        // build total line
        const totalLine = {
          name: 'Total',
          type: 'line',
          
          data: years.map(
            y => +ends.reduce((sum, e) => sum + (grouping[y][e]||0), 0).toFixed(2)
          ),
          lineStyle: { width: 2 },
          itemStyle: { color: '#000' }
        }

        // merge into baseOption
        setOption({
          ...baseOption,
          legend: {
            ...baseOption.legend,
            data: [...ends, 'Total'],
          },
          xAxis: {
            ...baseOption.xAxis,
            data: years,
          },
          series: [
            ...barSeries,
            totalLine
          ]
        })
      }
    })
  }, [])

  return (
    <ReactECharts
      option={option}
      style={{ height: "130%", width: '100%' }}
      notMerge={true}
      lazyUpdate={true}
    />
  )
}

export function SettlementDestinationEmissionsChart() {
  // static chart config
  const baseOption = {
    
    
    textStyle : {color: '#fff'},
    tooltip: {
      trigger: 'axis',
      axisPointer: { type: 'shadow' },
    },
    legend: { show: false },
    grid: {
      top: 30,
      left: 80,
      right: 100,
      bottom: 130,
      containLabel: true,
      textStyle : {color: '#fff'},
    },
    xAxis: {
      type: 'category',
      name: 'Año',
      data: [],           // ← filled at runtime
      axisLabel: { rotate: 90 },
    },
    yAxis: {
      type: 'value',
      name: 'CO₂ emitido (miles de toneladas)',
    },
    
    series: []          // ← filled at runtime
  }

  const [option, setOption] = useState(baseOption)

  useEffect(() => {
    Papa.parse('/data/csv/transitions_emissions.csv', {
      download: true,
      header: true,
      dynamicTyping: true,
      skipEmptyLines: true,
      complete: ({ data }) => {
        // 1) assign year = 2000 + rowIndex, filter to ≤2020
        const rows = data
          .map((r, i) => ({ ...r, year: 2000 + i }))
          .filter(r => r.year <= 2020)

        // 2) sum only the “settlements” destination
        const sumsByYear = {}
        rows.forEach(r => {
          Object.entries(r).forEach(([key, val]) => {
            if (key === 'year' || key.startsWith('Unnamed')) return
            // the slug always comes after “…conversion_”
            const parts = key.split('conversion_')
            if (parts.length < 2) return
            const [startTo, endSlug] = parts[1].split('_to_')
            if (endSlug !== 'settlements') return
            const y = r.year
            sumsByYear[y] = (sumsByYear[y] || 0) + Number(val || 0)
          })
        })

        // 3) build sorted arrays of years & values×1000
        const years = Object.keys(sumsByYear)
          .map(Number)
          .sort((a, b) => a - b)
        const values = years.map(y => Math.round(sumsByYear[y] * 1000 * 100) / 100);

        // 4) single line+area series for “Settlements”
        const slug = 'Asentamientos'
        const color = color_map_base[slug]

        console.log(color)

        const series = [
          {
            name: 'Asentamientos',
            type: 'line',
            data: values,
            smooth: true,
            showSymbol: true,
            color: color,
            lineStyle: { width: 2},
            areaStyle: { color, opacity: 0.3 },
          }
        ]

        // 5) merge in only xAxis.data & series
        setOption({
          ...baseOption,
          xAxis: { ...baseOption.xAxis, data: years },
          series,
        })
      }
    })
  }, [])

  return (
    <ReactECharts
      option={option}
      style={{ height: "130%", width: '100%' }}
      notMerge={true}
      lazyUpdate={true}
    />
  )
}

export function Emissions_Lost_Forest() {
  const prettifyColumn = rawKey => {
    const prefix = 'emission_co2e_co2_lndu_conversion_';
    if (!rawKey.startsWith(prefix)) return rawKey;
    const [start, end] = rawKey.slice(prefix.length).split('_to_');
    return `${COLUMN_NAME_MAP[start]}-${COLUMN_NAME_MAP[end]}`;
  };

  const baseOption = {

    textStyle: { color: '#fff' },
    tooltip: {
      trigger: 'axis',
      axisPointer: { type: 'cross' }
    },
    grid: {
      top: 40,
      left: 70,
      right: 100,
      bottom: 130,
      containLabel: true
    },
    xAxis: {
      name: 'Año',
      type: 'category',
      data: [],           // ← filled at runtime
      axisLabel: { color: '#fff' },
      axisLabel: { rotate: 90 },
    },
    yAxis: {
      type: 'value',
      name: 'CO₂ emitido (miles de toneladas)',
      nameTextStyle: { color: '#fff' },
      axisLabel: { color: '#fff' }
    },
    series: []          // ← filled at runtime
  };


  const [option, setOption] = useState(baseOption);

  useEffect(() => {
    Papa.parse('/data/csv/transitions_emissions.csv', {
      download: true,
      header: true,
      dynamicTyping: true,
      skipEmptyLines: true,
      complete: ({ data }) => {
        // 1) build rows with year and filter ≤2020
        const rows = data
          .map((r, i) => ({ ...r, year: 2000 + i }))
          .filter(r => r.year <= 2020);

        // 2) sum only the two forest‐loss columns per year
        const grouping = {};
        rows.forEach(r => {
          Object.entries(r).forEach(([key, val]) => {
            if (key === 'year' || key.startsWith('Unnamed')) return;
            const pretty = prettifyColumn(key);            // e.g. "Primary forests-Settlements"
            const [forestType] = pretty.split('-');
            if (!['Bosques primarios', 'Bosques secundarios'].includes(forestType)) return;
            grouping[r.year] = grouping[r.year] || 0;
            grouping[r.year] += Number(val || 0);
          });
        });

        // 3) extract sorted years and total values
        const years = Object.keys(grouping).map(Number).sort((a, b) => a - b);
        
        const totals = years.map(y => Math.round(grouping[y] * 100) / 100);

        // 4) single “area” series
        const areaSeries = {
          name: 'Total',
          type: 'line',
          smooth: true,
          areaStyle: { opacity: 0.3 },
          lineStyle: { width: 2 },
          itemStyle: { color: '#c23531' },
          data: totals
        };

        setOption({
          ...baseOption,
          xAxis: { ...baseOption.xAxis, data: years },
          series: [areaSeries]
        });
      }
    });
  }, []);


  return (
    <ReactECharts
      option={option}
      style={{ height: "130%", width: '100%' }}
      notMerge={true}
      lazyUpdate={true}
    />
  );
}

export function ParallelChart() {
  const baseOption = {
    tooltip: { trigger: "axis" },
    legend: {
      data: ["Área urbanizada (hectáreas)", "CO₂ no capturado (Miles de toneladas)"],
      top: 30,
      textStyle: { color: "#fff" },
      icon: "circle",
    },
    grid: {
      top: 80,
      bottom: 130,
      left: 50,
      right: 90,
      containLabel: true,
    },
    textStyle: { color: "#fff" },
    xAxis: {
      type: "category",
      data: [],
    },
    yAxis: [
      {
        type: "value",
        name: "Área urbanizada (hectáreas)",
        position: "left",
      },
      {
        type: "value",
        name: "CO₂ no capturado (Miles de toneladas)",
        position: "right",
      },
    ],
    series: [
      {
        name: "Área urbanizada (hectáreas)",
        type: "line",
        smooth: true,
        yAxisIndex: 0,
        
      },
      {
        name: "CO₂ no capturado (Miles de toneladas)",
        type: "line",
        smooth: true,
        yAxisIndex: 1,
      
      },
    ],
  };

  const [option, setOption] = useState(baseOption);

  useEffect(() => {
    Papa.parse("/data/csv/parallel.csv", {
      download: true,
      header: true,
      dynamicTyping: true,
      complete: ({ data }) => {
      const cleanData = data.filter(
        d =>
          d.year !== undefined &&
          d.urbanized_area_ha !== undefined &&
          d.co2_not_captured_kt !== undefined
      );

        const years = cleanData.map(d => d.year);
        const urbanized = cleanData.map(d => +(+d.urbanized_area_ha).toFixed(2));
        const co2 = cleanData.map(d => +(+d.co2_not_captured_kt).toFixed(2));
        setOption(opt => ({
          ...opt,
          xAxis: { ...opt.xAxis, data: years },
          series: [
            {
              name: "Área urbanizada (hectáreas)",
              type: "line",
              smooth: true,
              yAxisIndex: 0,
              data: urbanized,
              lineStyle: {width: 5 },
              symbolSize:7.5
            },
            {
              name: "CO₂ no capturado (Miles de toneladas)",
              type: "line",
              smooth: true,
              yAxisIndex: 1,
              data: co2,
              lineStyle: {width: 5 },
              symbolSize:7.5
            },
          ],
        }));
      },
    });
  }, []);

  return (
    <ReactECharts
      option={option}
      style={{ height: "130%", width: "100%" }}
      notMerge={true}
      lazyUpdate={true}
    />
  );
}


export function CombinedScenarioChart() {
  const [opt, setOpt] = React.useState(null);

  React.useEffect(() => {
    async function buildOption() {
      const [fastTxt, normalTxt, slowTxt] = await Promise.all(
        ["fast", "normal", "slow"].map(f =>
          fetch(`/data/csv/forecast/area/${f}.csv`).then(r => r.text())
        )
      );
      const [fastRows, normalRows, slowRows] = [fastTxt, normalTxt, slowTxt].map(txt =>
        Papa.parse(txt, { header: true, skipEmptyLines: true, dynamicTyping: true }).data
      );

      const pivotByYear = (rows) => {
        const offsets = Object.keys(rows[0]).filter(k => k !== "label");
        const pivot = {};
        rows.forEach(row => {
          offsets.forEach(off => {
            const year = 2000 + Number(off);
            if (!pivot[year]) pivot[year] = {};
            pivot[year][row.label] = parseFloat(((row[off] || 0) / 100).toFixed(2));
          });
        });
        return pivot;
      };

      const fast = pivotByYear(fastRows);
      const normal = pivotByYear(normalRows);
      const slow = pivotByYear(slowRows);

      const years = Object.keys(fast).map(Number).sort((a, b) => a - b);
      const split = 2022;

      const sumKeys = (map, y, keys) =>
        parseFloat(
          keys.reduce((sum, key) => sum + (map[y]?.[key] || 0), 0).toFixed(2)
        );

      // --- subplot key groups ---
      const KEYS_FORESTS = ["forests_primary", "forests_secondary"];
      const KEYS_SETT    = ["settlements"];

      // Helpers to build the 4 series arrays for a given key set
      const buildSeriesArrays = (KEYS) => {
        const hist   = years.map(y => (y <= split ? sumKeys(fast,   y, KEYS) : null));
        const sFast  = years.map(y => (y >  split ? sumKeys(fast,   y, KEYS) : null));
        const sNorm  = years.map(y => (y >  split ? sumKeys(normal, y, KEYS) : null));
        const sSlow  = years.map(y => (y >  split ? sumKeys(slow,   y, KEYS) : null));
        return { hist, sFast, sNorm, sSlow };
      };

      const forests = buildSeriesArrays(KEYS_FORESTS);
      const sett    = buildSeriesArrays(KEYS_SETT);

      const COLORS = {
        Historico: "gray",
        Rapido: "red",
        Normal: "black",
        Lento: "green",
      };

      setOpt({
        backgroundColor: "transparent",
        textStyle: { color: "#fff" },

        // One legend for everything
        legend: {
          top: 0,
          left: "center",
          icon: "circle",
          textStyle: { color: "#fff" },
          data: [
            { name: "Histórico", itemStyle: { color: COLORS.Historico } },
            { name: "Rápido",    itemStyle: { color: COLORS.Rapido    } },
            { name: "Normal",    itemStyle: { color: COLORS.Normal    } },
            { name: "Lento",     itemStyle: { color: COLORS.Lento     } },
          ],
        },

        // Two stacked grids (subplots)
        grid: [
  { top: 80, left: 50, right: "55%", bottom: 60, containLabel: true }, // Left: Bosques
  { top: 80, left: "55%", right: 50, bottom: 60, containLabel: true }  // Right: Asentamientos
],

        // Shared category axis values
        xAxis: [
          {
            type: "category",
            data: years,
            name: "Año",
            axisLabel: { rotate: 90, color: "#fff" },
            gridIndex: 0,
          },
          {
            type: "category",
            data: years,
            name: "Año",
            axisLabel: { rotate: 90, color: "#fff" },
            gridIndex: 1,
          }
        ],

        // Separate Y axes (same units)
        yAxis: [
          {
            type: "value",
            name: "Área (km²)",
            axisLabel: { formatter: v => v.toLocaleString() },
            gridIndex: 0,
          },
          {
            type: "value",
            name: "Área (km²)",
            axisLabel: { formatter: v => v.toLocaleString() },
            gridIndex: 1,
          }
        ],

        // Link tooltips & axis pointers across both subplots
        tooltip: { trigger: "axis", axisPointer: { type: "line" } },


        // Labels (subplot titles)
        title: [
  { text: "Bosques",       left: "20%",    top: 18, textStyle: { color: "#fff", fontSize: 14, fontWeight: "bold" } },
  { text: "Asentamientos", left: "75%", top: 18, textStyle: { color: "#fff", fontSize: 14, fontWeight: "bold" } },
],

        // Eight total series: 4 for Bosques (grid 0) + 4 for Asentamientos (grid 1)
        series: [
          // --- Bosques (gridIndex 0 / xAxisIndex 0 / yAxisIndex 0) ---
          { name: "Histórico", type: "line", data: forests.hist,  smooth: true, lineStyle: { width: 2 }, itemStyle: { color: COLORS.Historico }, xAxisIndex: 0, yAxisIndex: 0 },
          { name: "Rápido",    type: "line", data: forests.sFast, smooth: true, lineStyle: { width: 2 }, itemStyle: { color: COLORS.Rapido    }, xAxisIndex: 0, yAxisIndex: 0 },
          { name: "Normal",    type: "line", data: forests.sNorm, smooth: true, lineStyle: { width: 2 }, itemStyle: { color: COLORS.Normal    }, xAxisIndex: 0, yAxisIndex: 0 },
          { name: "Lento",     type: "line", data: forests.sSlow, smooth: true, lineStyle: { width: 2 }, itemStyle: { color: COLORS.Lento     }, xAxisIndex: 0, yAxisIndex: 0 },

          // --- Asentamientos (gridIndex 1 / xAxisIndex 1 / yAxisIndex 1) ---
          { name: "Histórico", type: "line", data: sett.hist,  smooth: true, lineStyle: { width: 2 }, itemStyle: { color: COLORS.Historico }, xAxisIndex: 1, yAxisIndex: 1 },
          { name: "Rápido",    type: "line", data: sett.sFast, smooth: true, lineStyle: { width: 2 }, itemStyle: { color: COLORS.Rapido    }, xAxisIndex: 1, yAxisIndex: 1 },
          { name: "Normal",    type: "line", data: sett.sNorm, smooth: true, lineStyle: { width: 2 }, itemStyle: { color: COLORS.Normal    }, xAxisIndex: 1, yAxisIndex: 1 },
          { name: "Lento",     type: "line", data: sett.sSlow, smooth: true, lineStyle: { width: 2 }, itemStyle: { color: COLORS.Lento     }, xAxisIndex: 1, yAxisIndex: 1 },
        ],
      });
    }

    buildOption();
  }, []);

  // Give it enough height for two subplots + legend + slider
  return opt ? (
    <ReactECharts
      option={opt}
      style={{ width: "155%", height: "100%" }}
      notMerge={true}
      lazyUpdate={true}
    />
  ) : null;
}


export function SequestrationScenarioChart() {
  const [option, setOption] = useState(null);

  useEffect(() => {
    async function load() {
      const histTxt = await fetch('/data/csv/emissions.csv').then(r => r.text());
      const histData = Papa.parse(histTxt, {
        header: true,
        skipEmptyLines: true,
        dynamicTyping: true
      }).data;
      const sumCols = [
        'emission_co2e_co2_lndu_biomass_sequestration_grasslands',
        'emission_co2e_co2_lndu_biomass_sequestration_other',
        'emission_co2e_co2_lndu_biomass_sequestration_pastures',
        'emission_co2e_co2_lndu_biomass_sequestration_settlements',
        'emission_co2e_co2_lndu_biomass_sequestration_shrublands',
        'emission_co2e_co2_lndu_biomass_sequestration_wetlands',
        'emission_co2e_subsector_total_frst'
      ];
      const splitYear = 2020;
      const histYears = [];
      const histValues = [];
      histData.forEach(r => {
        if (r.time_period != null) {
          const year = 2000 + r.time_period;
          if (year <= splitYear) {
            histYears.push(year);
            // sum & convert to thousands of tons (positive)
            const sum = sumCols.reduce((s, c) => s + (r[c] || 0), 0);
            histValues.push(Math.abs((Math.round(sum * 1000 * 100) / 100).toFixed(2)));
          }
        }
      });

      const dfs = await Promise.all(
        ['fast', 'normal', 'slow'].map(f =>
          fetch(`/data/csv/forecast/emissions/${f}.csv`)
            .then(r => r.text())
            .then(txt =>
              Papa.parse(txt, {
                header: true,
                skipEmptyLines: true,
                dynamicTyping: true
              }).data
            )
        )
      );
      const [fastDf, normalDf, slowDf] = dfs;
      const forecast = df =>
        df.map(r => {
          const sum = sumCols.reduce((s, c) => s + (+r[c] || 0), 0);
          return Math.abs((Math.round(sum * 1000 * 100) / 100).toFixed(2));
        });

      const years = fastDf
        .filter(r => r.time_period != null)
        .map(r => 2000 + r.time_period)
        .filter(y => y);
      const fastVals = forecast(fastDf);
      const normalVals = forecast(normalDf);
      const slowVals = forecast(slowDf);

      setOption({
        tooltip: { trigger: 'axis' },
        legend: {
          data: ['Histórico', 'Rápido', 'Normal', 'Lento'],
          top: 0,
          right: 80,
          icon: 'circle',
          textStyle: { color: '#fff' },
          
          left: 'center'
        },
        grid: {
          top: 50,
          bottom: 160,
          left: 80,
          right: 75,
          containLabel: true
        },
        textStyle: { color: '#fff' },
        xAxis: { type: 'category', data: years, name: 'Año', axisLabel: { rotate: 90, color: '#fff' }},
        yAxis: {
          type: 'value',
          name: 'Carbono capturado (miles de toneladas)',
          axisLabel: { formatter: v => v.toLocaleString() }
        },
        series: [
          {
            name: 'Histórico',
            type: 'line',
            itemStyle: { color: 'gray' },
            data: years.map((y, i) =>
              y <= splitYear ? histValues[i] : null
            ),
            lineStyle: { width: 2, color: 'gray' },
            smooth: true
          },
          {
            name: 'Rápido',
            type: 'line',
            itemStyle: { color: 'red' },
            data: years.map((y, i) =>
              y > splitYear ? fastVals[i] : null
            ),
            lineStyle: { width: 2 },
            smooth: true
          },
          {
            name: 'Normal',
            type: 'line',
            itemStyle: { color: 'black' },
            data: years.map((y, i) =>
              y > splitYear ? normalVals[i] : null
            ),
            lineStyle: { width: 2 },
            smooth: true
          },
          {
            name: 'Lento',
            type: 'line',
            itemStyle: { color: 'green' },
            data: years.map((y, i) =>
              y > splitYear ? slowVals[i] : null
            ),
            lineStyle: { width: 2 },
            smooth: true
          }
        ]
      });
    }

    load();
  }, []);

  return option ? (
    <ReactECharts option={option} style={{ height: '135%', width: '100%' }} />
  ) : null;
}

export function SequestrationScenarioGauges() {
  const [dataByYear, setDataByYear] = useState({});
  const [years, setYears] = useState([]);
  const [year, setYear] = useState(null);
  const [diffSummary, setDiffSummary] = useState({ diff: 0, percent: 0, cars: 0 });

  const colorMap = {
    'Rápido': '#c23531',
    'Normal': '#000000',
    'Lento': '#008000',
    'Diferencia': '#ffa500'
  };

  useEffect(() => {
    async function load() {
      const sumCols = [
        'emission_co2e_co2_lndu_biomass_sequestration_grasslands',
        'emission_co2e_co2_lndu_biomass_sequestration_other',
        'emission_co2e_co2_lndu_biomass_sequestration_pastures',
        'emission_co2e_co2_lndu_biomass_sequestration_settlements',
        'emission_co2e_co2_lndu_biomass_sequestration_shrublands',
        'emission_co2e_co2_lndu_biomass_sequestration_wetlands',
        'emission_co2e_subsector_total_frst'
      ];

      const calcVal = (r) => {
        const sum = sumCols.reduce((s, c) => s + (+r[c] || 0), 0);
        return Math.round(Math.abs(sum * 1000 * 100)) / 100;
      };

      const files = ['fast', 'normal', 'slow'];
      const [fastDf, normalDf, slowDf] = await Promise.all(
        files.map(file =>
          fetch(`/data/csv/forecast/emissions/${file}.csv`)
            .then(r => r.text())
            .then(txt =>
              Papa.parse(txt, {
                header: true,
                skipEmptyLines: true,
                dynamicTyping: true
              }).data
            )
        )
      );

      const yearsArray = fastDf.map(r => 2000 + r.time_period).filter(Boolean);
      const uniqueYears = [...new Set(yearsArray)].sort((a, b) => a - b);

      const byYear = {};
      const startYear = 2022;
      let fastAcc = 0;
      let normalAcc = 0;
      let slowAcc = 0;
      let diffAcc = 0;

      uniqueYears.forEach((yr, i) => {
        const fastVal = calcVal(fastDf[i]);
        const normalVal = calcVal(normalDf[i]);
        const slowVal = calcVal(slowDf[i]);
        const diffVal = Math.abs(slowVal - fastVal);

        if (yr >= startYear) {
          fastAcc += fastVal;
          normalAcc += normalVal;
          slowAcc += slowVal;
          diffAcc += diffVal;

          byYear[yr] = {
            'Rápido': fastAcc.toFixed(2),
            'Normal': normalAcc.toFixed(2),
            'Lento': slowAcc.toFixed(2),
            "Diferencia": diffAcc.toFixed(2)
          };
        }
      });

      setDataByYear(byYear);
      setYears(uniqueYears);
      setYear(uniqueYears[22] || uniqueYears[0]);

      // Compute % summary from totals (2022 to last year)
      
      const carEquivalent = (slowAcc / 60);
      setDiffSummary({
        diff: diffAcc.toFixed(2),
        cars: carEquivalent.toFixed(0),
      });
    }

    load();
  }, []);

  const makeGaugeOption = (scenario, value) => ({
    series: [
      {
        type: 'gauge',
        startAngle: 180,
        endAngle: 0,
        min: 0,
        progress: {
          show: true,
          width: 18,
          itemStyle: { color: colorMap[scenario] }
        },
        axisLine: {
          lineStyle: {
            width: 18,
            color: [[2, colorMap[scenario]]]
          }
        },
        axisTick: { show: false },
        splitLine: { show: false },
        axisLabel: { show: false },
        pointer: { show: false },
        anchor: { show: false },
        title: {
          show: true,
          offsetCenter: [0, '70%'],
          fontSize: 14,
          color: '#fff'
        },
        detail: {
          valueAnimation: true,
          fontSize: 14,
          offsetCenter: [0, '20%'],
          color: '#fff'
        },
        data: [{ value, name: scenario }]
      }
    ]
  });

  if (year === null || !dataByYear[year]) return null;

  return (
    <Box sx={{ width: '100%', color: 'white', textAlign: 'center', height: '100%' }}>
      <Box sx={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', flexDirection: 'column', alignItems: 'center' }}>
        <Typography variant="subtitle1" sx={{ width: '100%', mt: 0, mb: 2, color: 'white', fontWeight: 'bold' }}>
          Miles de toneladas de CO₂ capturado
        </Typography>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: {
              xs: '1fr 1fr 1fr 1fr',
              sm: '1fr 1fr 1fr 1fr',
              md: '1fr 1fr 1fr 1fr'
            },
            justifyItems: 'center',
            rowGap: 0.5,
            columnGap: 4,
            px: { sm:2 }
          }}
        >
          {['Normal', 'Rápido', 'Lento', 'Diferencia'].map((scenario, i) => (
            <Box
              key={i}
              sx={{
                width: {
                  xs: 60,
                  sm: 40,
                  md: 100
                },
                height: {
                  xs: 60,
                  sm: 40,
                  md: 100
                }
              }}
            >
              <ReactECharts
                option={makeGaugeOption(scenario, dataByYear[year][scenario])}
                style={{ height: '100%', width: '100%' }}
              />
            </Box>
          ))}
        </Box>
        <Slider
          value={year}
          min={years[22]}
          max={years[years.length - 1]}
          step={1}
          marks
          valueLabelDisplay="auto"
          onChange={(_, v) => setYear(v)}
          sx={{ width: '60%', mx: 'auto', mb: -1, color: 'white', }}
        />
        
        <Typography variant="h6" sx={{ fontWeight: 'bold'}}>
          Año: {year}
        </Typography>


        <Typography
          variant="body2"
          sx={{
            color: '#ffcc00',
            fontWeight: 'bold',
            textAlign: 'center',
          }}
        >
          El escenario lento permite capturar {Number(diffSummary.diff).toFixed(2)} mil toneladas más que en el escenario rápido, equivalente a la captura de {Number((((diffSummary.diff)*1000)/130).toFixed(0)).toLocaleString()} mil árboles en un período de 13 años.
        </Typography>                 
      </Box>

     
    </Box>
  );
}